import {CommandKeybindingHint} from '@github-ui/ui-commands'
import {Dialog} from '@primer/react/experimental'
import {createPortal} from 'react-dom'

export function TextAreaHelpDialog({onDismiss}: {onDismiss: () => void}) {
  return createPortal(
    <Dialog width="large" aria-label="Code blob focused hotkeys" onClose={onDismiss} title="Code blob focused hotkeys">
      <div>
        <div>
          <div className="p-1">
            Select the line the cursor is on <CommandKeybindingHint commandId="code-view:highlight-line" />
          </div>
          <div className="p-1">
            Select the symbol under the cursor <CommandKeybindingHint commandId="code-view:inspect-symbol" />
          </div>
          <div className="p-1">
            Move focus to the highlighted line menu <CommandKeybindingHint commandId="code-view:open-line-menu" />
          </div>
        </div>
      </div>
    </Dialog>,
    document.body,
  )
}
